export default {
  data () { return { cityActivityPaused: false, cityReducedMotion: false, cityPageHidden: false, patrolGreeting: false, cityDetailPosition: { top: '12px', maxHeight: 'calc(100% - 24px)' } } },
  computed: {
    cityActivityStopped () { return this.cityActivityPaused || this.cityReducedMotion || this.cityPageHidden },
    cityActivityLabel () { return this.cityReducedMotion ? '已减少动态' : this.cityActivityPaused ? '继续动态' : '暂停动态' }
  },
  mounted () {
    this.cityMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
    this.cityMotionListener = () => { this.cityReducedMotion = this.cityMotionQuery.matches }
    this.cityVisibilityListener = () => { this.cityPageHidden = document.hidden }
    this.cityMotionQuery.addEventListener('change', this.cityMotionListener)
    document.addEventListener('visibilitychange', this.cityVisibilityListener)
    this.cityDetailPositionListener = () => this.positionMapDetail()
    window.addEventListener('scroll', this.cityDetailPositionListener, { passive: true, capture: true })
    window.addEventListener('resize', this.cityDetailPositionListener, { passive: true })
    this.cityMotionListener(); this.cityVisibilityListener(); this.$nextTick(this.syncCityPresentation)
  },
  beforeDestroy () {
    this.cityMotionQuery?.removeEventListener('change', this.cityMotionListener)
    document.removeEventListener('visibilitychange', this.cityVisibilityListener)
    window.removeEventListener('scroll', this.cityDetailPositionListener, true)
    window.removeEventListener('resize', this.cityDetailPositionListener)
    this.citySelectionTarget = null
  },
  watch: {
    cityActivityStopped () { this.$nextTick(this.syncCityPresentation) },
    patrolGreeting () { this.$nextTick(this.syncCityPresentation) },
    selection () { this.positionMapDetail(); this.$nextTick(this.syncCityPresentation) },
    markup () { this.$nextTick(this.syncCityPresentation) },
    activeCaseId () { this.$nextTick(this.syncCityPresentation) }
  },
  methods: {
    positionMapDetail () {
      if (!this.selection || !this.isIsometric || !this.$refs.mapViewport) return
      const rect = this.$refs.mapViewport.getBoundingClientRect(), visibleTop = Math.max(0, rect.top), visibleBottom = Math.min(window.innerHeight, rect.bottom)
      this.cityDetailPosition = { top: `${Math.max(12, visibleTop - rect.top + 12)}px`, maxHeight: `${Math.max(100, visibleBottom - visibleTop - 24)}px` }
    },
    detailKeydown (event) { if (event.key === 'Escape') { event.preventDefault(); this.closeMapSelection() } },
    syncCityPresentation () {
      const stage = this.$refs.mapStage, svg = stage?.querySelector('[data-isometric-map]')
      stage?.querySelectorAll('[data-case]').forEach(el => { el.classList.toggle('is-active-case', el.getAttribute('data-case') === this.activeCaseId) })
      if (!svg) return
      if (this.cityActivityStopped) svg.pauseAnimations(); else svg.unpauseAnimations()
      svg.classList.toggle('is-greeting', this.patrolGreeting)
      svg.classList.toggle('is-motion-paused', this.cityActivityStopped)
      const attribute = { part: 'data-pt', cell: 'data-cell', landmark: 'data-iso-landmark', patrol: 'data-city-actor', grid: 'data-map-grid', case: 'data-case' }[this.selection?.kind]
      stage.querySelectorAll('.iso-selected').forEach(el => el.classList.remove('iso-selected'))
      if (attribute) stage.querySelectorAll(`[${attribute}]`).forEach(el => { if (el.getAttribute(attribute) === this.selection.key) el.classList.add('iso-selected') })
    },
    showMapSelection (selection, target) {
      if (this.emitOnly) return
      this.selection = selection; this.citySelectionTarget = target
      // 不抢走鼠标焦点，允许连续选择其他点位；键盘用户可直接Tab进入详情。
    },
    closeMapSelection () {
      this.selection = null
      if (this.citySelectionTarget?.isConnected) this.citySelectionTarget.focus({ preventScroll: true })
      this.citySelectionTarget = null
    },
    inspectPatrol (target) {
      this.showMapSelection({ kind: 'patrol', key: 'patrol', badge: '城市互动', title: '社区巡查员', fields: [{ label: '互动方式', value: '点击下方按钮打个招呼' }, { label: '人物说明', value: '城市场景中的展示人物' }], description: '行人和车辆沿当前路网移动。点击部件、建筑或区域标签，可查看地图配置详情。' }, target)
    }
  }
}
